<template>
  <div>
    <el-row :gutter="10" class="mb-20 mt-20">
      <el-col :md="2" :lg="2">
        <el-input v-model="listQuery.identity" placeholder="请输入设备唯一标识" size="mini"/>
      </el-col>
      <el-col :md="2" :lg="2">
        <el-input v-model="listQuery.address" placeholder="请输入设备地址" size="mini"/>
      </el-col>
      <el-col :md="2" :lg="2">
        <el-select v-model="listQuery.state" style="width: 100%" size="mini" clearable placeholder="请选择">
          <el-option
            v-for="item in optionsStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"/>
        </el-select>
      </el-col>
      <el-col :md="2" :lg="1">
        <el-button type="primary" size="mini" @click="search">搜索</el-button>
      </el-col>
      <el-col :md="2" :lg="2" style="text-align:right">
        <el-link type="primary" @click="handleBindAgent">绑定代理商</el-link>
      </el-col>
      <el-col :md="2" :lg="2" style="margin-left: auto">
        <el-link type="primary" @click="handleAddDevice">
          <i class="el-icon-plus"/>
          新增设备
        </el-link>
      </el-col>
      <el-col v-if="fieldid" :md="3" :lg="3" style="margin-left: auto;">
        <el-link type="primary" @click="handleBindField">
          <i class="el-icon-plus"/>
          绑定已添加设备
        </el-link>
      </el-col>
    </el-row>
    <el-table
      :data="deviceData"
      fit
      style="width: 100%"
      @selection-change="handleSelectionChange">
      <el-table-column
        :label="$t('table.change')"
        fixed
        prop="Identity"
        type="selection"
        align="center"

      >
        <!-- <template>
              <el-checkbox v-model="checked">备选项</el-checkbox>
            </template>-->
      </el-table-column>
      <el-table-column
        :label="$t('table.imei')"
        prop="Identity"
        fixed="left"
        align="center"

      >
        <template slot-scope="scope">
          <span v-if="scope.row.LsList.Identity" style="color: #409EFF">{{ scope.row.LsList.Identity }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('table.deviceName')"
        fixed="left"

        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.LsList.Name">{{ scope.row.LsList.Name }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column :label="`场地名称`" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.FieldName">{{ scope.row.FieldName }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column :label="`代理商名称`" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.AgentName">{{ scope.row.AgentName }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column :label="`代理商手机号`" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.AgentTel">{{ scope.row.AgentTel }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.address')" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.LsList.Address">{{ scope.row.LsList.Address }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <!-- <template v-if="roleId === 1">
          <el-table-column :label="`是否隐藏`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.IsOpenHide">已隐藏</span>
              <span v-else>未隐藏</span>
            </template>
          </el-table-column>
          <el-table-column :label="`隐藏比例`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.HideProportion">{{ scope.row.LsList.HideProportion }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column :label="`隐藏基数`" align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.LsList.StartHideCount">{{ scope.row.LsList.StartHideCount }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </template>

        <el-table-column :label="$t('table.memberCount')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.Count || 0 }}</span>
          </template>
        </el-table-column> -->
      <!-- <el-table-column :label="$t('table.maxMemberCount')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.MemberCount || 0 }}</span>
            </template>
          </el-table-column> -->
      <!-- <el-table-column :label="$t('table.isDepositTel')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.LsList.IsDepositTel === 'Y' ? '是' : scope.row.LsList.IsDepositTel === 'N' ? '否' : '--' }}</span>
          </template>
        </el-table-column> -->
      <el-table-column :label="$t('table.lineStatus')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.LineState === 'On' ? '在线' : scope.row.LineState === 'Off' ? '离线' : '--' }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column :label="$t('table.status')" align="center">
            <template slot-scope="scope">
              <span
                v-if="scope.row.LsList.StatusNo"
              >{{ scope.row.LsList.StatusNo === 'A' ? '管理员添加' : scope.row.LsList.StatusNo === 'S' ? '离线' : '--' }}</span>
              <span v-else>--</span>
            </template>
          </el-table-column> -->
      <!-- <el-table-column :label="$t('table.cellNum')" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.LsList.BoxInfos ? scope.row.LsList.BoxInfos.length : '--' }}</span>
            </template>
          </el-table-column>-->
      <el-table-column :label="$t('table.userCount')" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.LsList.UseTotalCount">{{ scope.row.LsList.UseTotalCount || 0 }}</span>
          <span v-else>0</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.totalIncome')" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.LsList.TotalIncome || 0 }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.lastConnTime')" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.LsList.LastLinkTime">{{ scope.row.LsList.LastLinkTime }}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="200" fixed="right">
        <template slot-scope="scope">
          <el-link
            v-if="calcPermission(permition, 1) && scope.row.LsList.StatusNo === 'S'"
            class="custom-link"
            type="success"
            @click="handleEnabled(scope.row)"
          >启用</el-link>
          <el-link
            v-if="calcPermission(permition, 1) && scope.row.LsList.StatusNo === 'A'"
            class="custom-link"
            type="danger"
            @click="handleDis(scope.row)"
          >禁用</el-link>
          <el-link
            v-if="calcPermission(permition, 1)"
            class="custom-link"
            type="primary"
            @click="handleDeviceEdit(scope.row.LsList)"
          >{{ $t('table.edit') }}</el-link>
          <el-link
            v-if="calcPermission(permition, 3)"
            class="custom-link"
            type="primary"
            @click="handleDetail(scope.row)"
          >详情</el-link>
          <el-dropdown v-if="calcPermission(permition, 4) || calcPermission(permition, 5) || calcPermission(permition, 6)">
            <el-link type="primary">
              <i class="el-icon-more"/>
            </el-link>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item>
                  <el-link
                    v-if="calcPermission(permition, 5)"
                    :underline="false"
                    class="custom-link"
                    @click="bindAgent(scope.row.LsList)"
                  >{{ $t('table.bindAgent') }}</el-link>
                </el-dropdown-item> -->
              <el-dropdown-item>
                <el-link
                  v-if="calcPermission(permition, 6) && scope.row.LsList.Url"
                  :underline="false"
                  class="custom-link"
                  @click="downQRcode(scope.row.LsList)"
                >{{ $t('table.downloadQRcode') }}</el-link>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        v-show="total>0"
        :current-page="listQuery.pageIndex"
        :page-sizes="[10,20,50,100]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <!-- 添加设备弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      title="添加设备"
      width="40%">
      <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="120px" class="demo-dataForm">
        <el-form-item label="设备唯一标识号" prop="Identity">
          <el-input v-model="dataForm.Identity" placeholder="请输入设备唯一标识号"/>
        </el-form-item>
        <el-form-item label="设备名称" prop="Name">
          <el-input v-model="dataForm.Name" placeholder="请输入设备名称"/>
        </el-form-item>
        <el-form-item label="设备地址" prop="Address">
          <el-input v-model="dataForm.Address" placeholder="请输入设备地址"/>
        </el-form-item>
        <!-- <el-form-item label="经度" prop="Longitude">
          <el-input v-model="dataForm.Longitude" placeholder="经度"/>
        </el-form-item>
        <el-form-item label="纬度" prop="Latitude">
          <el-input v-model="dataForm.Latitude" placeholder="纬度"/>
        </el-form-item> -->
        <!-- <el-form-item label="员工柜子数量" prop="MemberCount">
          <el-input v-model="dataForm.MemberCount" placeholder="员工柜子数量"/>
        </el-form-item> -->
        <el-form-item label="一拖几" prop="CabinetCount">
          <el-input v-model="dataForm.CabinetCount" type="number" placeholder="一拖几，请输入数字"/>
        </el-form-item>
        <el-form-item label="几门" prop="DoorCount">
          <el-input v-model="dataForm.DoorCount" type="number" placeholder="几门，请输入数字"/>
        </el-form-item>
        <el-form-item label="箱子编号" prop="BoxCode">
          <el-input v-model="dataForm.BoxCode" placeholder="箱子编号（A-Z）"/>
        </el-form-item>
        <el-form-item label="箱子备注" prop="MidMemo">
          <el-input v-model="dataForm.MidMemo" placeholder="箱子备注"/>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleDialog('dataForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 下载二维码 -->
    <el-dialog :visible.sync="qrcode" title="下载二维码" width="30%">
      <div id="qrcod" ref="qrcode"/>
      <span slot="footer" class="dialog-footer">
        <el-button @click="qrcode = false">取 消</el-button>
        <el-button type="primary" @click="downcode">下 载</el-button>
      </span>
    </el-dialog>
    <!-- 绑定代理商弹窗 -->
    <el-dialog
      :visible.sync="bindAgentVisble"
      :before-close="handleClose"
      title="绑定代理商"
      width="30%">
      <div style="text-align: center; margin: 30px auto;">
        <el-select v-model="bindAgentDataForm.Id" filterable placeholder="请选择代理商">
          <el-option
            v-for="item in options"
            :key="item.UserId"
            :label="item.UserName"
            :value="item.UserId">
            <span style="float: left">{{ item.UserName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px" @click="handleAgentEdit(item)">编辑</span>
          </el-option>
        </el-select>
        <el-button icon="el-icon-plus" round type="primary" @click="handleAddAgent"/>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindAgentVisble = false">取 消</el-button>
        <el-button type="primary" @click="confirmBindAgent">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加编辑代理商 -->
    <el-drawer
      ref="drawer"
      :before-close="handleClose"
      :visible.sync="dialog"
      title="添加代理商"
      direction="rtl"
      custom-class="demo-drawer"
    >
      <div class="demo-drawer__content">
        <el-form ref="form" :model="form" :rules="rulesForm">
          <el-form-item label="登录账号" label-width="100px" prop="LoginNo">
            <el-input v-model="form.LoginNo" placeholder="请输入登录账号"/>
          </el-form-item>
          <el-form-item v-if="userFlag" label="密码" label-width="100px" prop="Password">
            <el-input v-model="form.Password" type="password" placeholder="请输入密码"/>
          </el-form-item>
          <el-form-item label="用户名" label-width="100px" prop="UserName">
            <el-input v-model="form.UserName" placeholder="请输入用户名"/>
          </el-form-item>
          <el-form-item label="手机号" label-width="100px" prop="TelPhone">
            <el-input v-model="form.TelPhone" placeholder="请输入手机号"/>
          </el-form-item>
          <el-form-item label="状态" label-width="100px" prop="StatusNo">
            <el-select v-model="form.StatusNo" placeholder="请选择">
              <el-option
                v-for="item in optionsStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="demo-drawer__footer">
          <el-button @click="cancelForm">取 消</el-button>
          <!-- <el-button :loading="loading" type="primary" @click="$refs.drawer.closeDrawer()">{{ '确 定' }}</el-button> -->
          <el-button type="primary" @click="handleConfirm">{{ '确 定' }}</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 场地添加设备弹窗 -->
    <el-dialog
      :visible.sync="bindDeviceVisible"
      :before-close="handleClose"
      title="场地绑定选择设备"
      width="30%">
      <div style="text-align: center" class="mt-20 mb-20">
        <el-select v-model="bindDeviceDataForm.dIds" multiple placeholder="请选择设备号">
          <el-option
            v-for="item in deviceOptions"
            :key="item.DId"
            :label="item.Identity"
            :value="item.DId"/>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirmAddDevice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { qryDeviceInfo, txDevice, updateDeviceState, binDingAgent, binDingField } from '@/api/device'
import { qryUser, addUser, modUser } from '@/api/user'
import { qryRoleInfo } from '@/api/baseModule'
import QrCode from 'qrcodejs2'
import md5 from 'js-md5'
export default {
  name: 'Device',
  props: {
    fieldid: {
      type: Number,
      default: null
    }
  },
  data() {
    var validatorLetter = (rule, value, callback) => {
      if (!value) {
        console.log(111)
        callback()
      } else {
        if (/^[A-Z]$/.test(value)) {
          callback()
        } else {
          callback(new Error('请填写A-Z之间的大写字母'))
        }
      }
    }
    var validateCount = (rule, value, callback) => {
      if (/^[1-9][0-9]*$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入大于0的正整数'))
      }
    }
    return {
      detail: null,
      qrcode: false,
      rules: {
        Identity: [
          { required: true, message: '请输入设备唯一标识', trigger: 'blur' }
        ],
        Name: [{ required: true, message: '请输入设备名称', trigger: 'blur' }],
        Address: [{ required: true, message: '请输入设备地址', trigger: 'blur' }],
        MemberCount: [{ required: true, message: '请输入最大员工柜子数量', trigger: 'blur' }],
        MidMemo: [{ required: false, message: '请输入中箱子备注', trigger: 'blur' }],
        BoxCode: [{ validator: validatorLetter, trigger: 'blur' }],
        CabinetCount: [
          { required: true, message: '请输入一拖几', trigger: 'blur' },
          { validator: validateCount, trigger: 'blur' }
        ],
        DoorCount: [
          { required: true, message: '请输入柜门数', trigger: 'blur' },
          { validator: validateCount, trigger: 'blur' }
        ]
      },
      rulesForm: {
        LoginNo: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { min: 1, max: 32, message: '长度在 1 到 32 个字符', trigger: 'blur' }
        ],
        Password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' }
        ],
        UserName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur' }
        ],
        TelPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 1, max: 18, message: '长度在 1 到 18 个字符', trigger: 'blur' }
        ],
        StatusNo: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      },
      dialogVisible: false,
      deviceData: [],
      listQuery: {
        fieldId: null,
        identity: null,
        address: null,
        state: null,
        pageIndex: 1,
        pageSize: 10
      },
      userFlag: true,
      dialog: false,
      form: {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 0,
        StatusNo: 'A'
      },
      bindDeviceVisible: false, // 场地选择设备弹窗判断
      bindDeviceDataForm: {
        Id: null,
        dIds: []
      },
      deviceOptions: [],
      bindAgentVisble: false,
      bindAgentDataForm: {
        Id: null,
        dIds: []
      },
      optionsStatus: [
        {
          label: '启用',
          value: 'A'
        },
        {
          label: '禁用',
          value: 'S'
        }
      ],
      options: [], // 代理商用户数据
      listQueryAgent: { // 查询代理商数据
        roleId: 2,
        pageIndex: 1,
        pageSize: 2147483647
      },
      qr: null,
      dataForm: {
        Did: 0,
        Identity: null,
        FieldId: 0,
        Name: null,
        Address: null,
        Longitude: 0,
        Latitude: 0,
        MemberCount: 0,
        IsDepositTel: 'N',
        IsFree: 'N',
        BoxCode: null,
        MidMemo: null,
        IsOpenHide: 0,
        HideProportion: 0,
        StartHideCount: 0,
        MaxHideCount: 0,
        Province: null,
        City: null,
        Area: null,
        CabinetCount: null,
        DoorCount: null,
        typeNo: 'Small'
      },
      total: 0,
      permition: 0
    }
  },
  created() {
    console.log(this.fieldid)
    this.listQuery.fieldId = this.dataForm.FieldId = this.fieldid
    if (this.$store.state.roleInfo) {
      this.$store.state.roleInfo.LsList[0].RolePrograms.forEach(item => {
        if (this.$route.path === item.ProgramInfo.PgUrl) {
          this.permition = item.Permition
          this.getDeviceList()
        }
      })
    } else {
      qryRoleInfo({
        rId: this.$store.getters.roles.RoleId
      }).then(response => {
        this.$store.state.roleInfo = response
        response.LsList[0].RolePrograms.forEach(item => {
          if (this.$route.path === item.ProgramInfo.PgUrl) {
            this.permition = item.Permition
            // console.log(response.LsList[0].RolePrograms)
            this.getDeviceList()
          }
        })
      })
    }
  },
  methods: {
    // 查询设备列表
    getDeviceList() {
      qryDeviceInfo(this.listQuery).then(res => {
        console.log(res)
        if (res) {
          this.deviceData = res.LsList
          this.total = res.TotalRows
        }
      })
    },
    getDeviceFilterList() {
      qryDeviceInfo({ pageIndex: 1, pageSize: 2147483647 }).then(res => {
        console.log(res)
        res.LsList.forEach(item => {
          if (!item.LsList.FieldId) {
            this.deviceOptions.push(item.LsList)
          }
        })
        console.log(this.deviceOptions)
      })
    },
    // 搜索
    search() {
      this.getDeviceList()
    },
    // 绑定设备弹窗
    handleBindField() {
      this.getDeviceFilterList()
      this.bindDeviceVisible = true
    },
    // 确定绑定设备
    handleConfirmAddDevice() {
      if (this.bindDeviceDataForm.dIds.length <= 0) {
        this.$message.error('请选择设备')
        return
      }
      this.bindDeviceDataForm.Id = this.fieldid
      binDingField(this.bindDeviceDataForm).then(res => {
        if (res) {
          this.$message.success('绑定成功')
          this.getDeviceList()
          this.resetBindDeviceDataForm()
          this.deviceOptions.dIds = []
          this.bindDeviceVisible = false
        }
      })
    },
    resetBindDeviceDataForm() {
      this.bindDeviceDataForm = {
        Id: null,
        dIds: []
      }
      this.deviceOptions = []
    },
    // 点击空白关闭弹窗
    handleClose(done) {
      this.resetDataForm()
      this.resetForm()
      this.resetBindDeviceDataForm()
      done()
    },
    // 取消
    handleCancel() {
      this.resetDataForm()
      this.resetBindDeviceDataForm()
      this.dialogVisible = false
      this.bindDeviceVisible = false
    },
    // 添加代理商
    handleAddAgent() {
      this.userFlag = true
      this.dialog = true
      this.form.RoleId = 2
    },
    // 取消代理商弹窗
    cancelForm() {
      this.resetForm()
      this.dialog = false
    },
    // 编辑设备信息
    handleDeviceEdit(item) {
      console.log(item)
      for (const key in this.dataForm) {
        this.dataForm[key] = item[key]
      }
      this.dataForm.Did = item.DId
      this.dialogVisible = true
      console.log(this.dataForm)
    },
    // 设备详情
    handleDetail(item) {
      console.log(item)
      this.$router.push({ path: '/deviceList', query: item })
    },
    // 添加设备
    handleAddDevice() {
      console.log(this.dataForm)

      this.dialogVisible = true
    },
    // 确定弹窗
    handleDialog(dataForm) {
      this.$refs[dataForm].validate(valid => {
        if (valid) {
          txDevice(this.dataForm).then(res => {
            if (res) {
              this.$message.success('添加成功')
              this.getDeviceList()
              this.resetDataForm()
              this.dialogVisible = false
            }
          })
        }
      })
    },
    // 设置用户状态
    setState(did, state) {
      updateDeviceState({
        did: did,
        state: state
      }).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '设置状态成功'
          })
          this.getDeviceList()
        }
      })
    },
    // 查询代理商数据
    getAgentList() {
      qryUser(this.listQueryAgent).then(res => {
        this.options = res.LsList
      })
    },
    // 绑定代理商弹窗
    handleBindAgent() {
      if (!this.bindAgentDataForm.dIds.length > 0) {
        this.$message.error('请先选择设备')
        return
      }
      this.getAgentList()
      this.bindAgentVisble = true
    },
    // 编辑代理商
    handleAgentEdit(item) {
      this.userFlag = false
      for (const key in this.form) {
        this.form[key] = item[key]
      }
      this.dialog = true
    },
    // 确定绑定代理商
    confirmBindAgent() {
      if (!this.bindAgentDataForm.Id) {
        this.$message.error('请选择代理商')
        return
      }
      binDingAgent(this.bindAgentDataForm).then(res => {
        if (res) {
          this.$message.success('绑定成功')
          this.getDeviceList()
          this.bindAgentVisble = false
          console.log(res)
        }
      })
    },
    // 表格选中状态
    handleSelectionChange(e) {
      console.log(e)
      this.bindAgentDataForm.dIds = e.map(item => {
        return item.LsList.DId
      })
      console.log(this.bindAgentDataForm)
    },
    // 弹窗确定提交
    handleConfirm() {
      console.log(this.form)
      this.form.Password = this.userFlag ? md5(this.form.Password) : this.form.Password
      this.$refs['form'].validate(valid => {
        if (valid) {
          if (this.form.UserId) { // 修改
            modUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.$message.success('修改成功')
                this.dialog = false
                this.resetForm()
                this.getAgentList()
              }
            })
          } else {
            addUser(this.form).then(res => {
              console.log(res)
              if (res) {
                this.dialog = false
                this.resetForm()
                this.getAgentList()
              }
            })
          }
        }
      })
    },
    // 重置dataForm
    resetDataForm() {
      this.dataForm = {
        Did: 0,
        Identity: null,
        FieldId: this.fieldid,
        Name: null,
        Address: null,
        Longitude: 0,
        Latitude: 0,
        MemberCount: 0,
        IsDepositTel: 'N',
        IsFree: 'N',
        BoxCode: null,
        MidMemo: null,
        IsOpenHide: 0,
        HideProportion: 0,
        StartHideCount: 0,
        MaxHideCount: 0,
        Province: null,
        City: null,
        Area: null,
        CabinetCount: null,
        DoorCount: null
      }
    },
    resetForm() {
      this.form = {
        UserId: 0,
        LoginNo: null,
        TelPhone: null,
        UserName: null,
        Password: null,
        RoleId: 0,
        StatusNo: 'A'
      }
    },
    // 启用
    handleEnabled(row) {
      console.log(row)
      this.setState(row.LsList.DId, 'A')
    },
    // 禁用
    handleDis(row) {
      console.log(row)
      this.setState(row.LsList.DId, 'S')
    },
    // 打开二维码下载界面
    downQRcode(detail) {
      this.qrcode = true
      this.detail = detail
      var Url = detail.Url
      this.$nextTick(() => {
        if (!this.qr) {
          this.qr = new QrCode('qrcod', {
            text: Url,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QrCode.CorrectLevel.H
          })
        } else {
          this.qr.makeCode(Url)
        }
      })
    },
    downcode(done) {
      // done()
      // console.log(done)
      var canvas = document.querySelector('#qrcod canvas')
      var url = canvas.toDataURL('image/jpeg')
      var a = document.createElement('a')
      var name = this.detail.Name
      document.getElementById('qrcod').appendChild(a)
      document.querySelector('#qrcod a').setAttribute('href', url)
      document.querySelector('#qrcod a').setAttribute('download', name + '.jpg')
      document.querySelector('#qrcod a').click()
    },
    handleSizeChange(e) {
      this.listQuery.pageSize = e
      this.getDeviceList()
    },
    handleCurrentChange(e) {
      this.listQuery.pageIndex = e
      this.getDeviceList()
    }
  }
}
</script>

<style lang="less" scoped>

</style>
